import { BodyText } from '@policygenius/mortar';
import isEmpty from 'lodash/isEmpty';
import React, { useMemo } from 'react';
import { FormRenderProps, useField } from 'react-final-form';

import FormWrapper from 'components/FormWrapper';
import Tooltip from 'components/Tooltip';
import { MaskedTextField } from 'forms/Inputs';
import DateField from 'forms/Inputs/DateField';
import ToggleField from 'forms/Inputs/ToggleField';
import { InitialValues } from 'forms/types';
import useFieldWithError from 'forms/utils/useFieldWithError';

import { BasicInfoFormValues } from './types';

const renderToolTip = (analytics: string, tooltipText: string) => (
  <Tooltip
    analyticsProperties={{
      triggeredFrom: `${analytics}-tooltip`,
    }}
  >
    <BodyText>{tooltipText}</BodyText>
  </Tooltip>
);
const dobToolTip = renderToolTip(
  'dob',
  'Rates go up as you get older, so insurance companies require us to ask this.'
);

type Props = FormRenderProps<BasicInfoFormValues, InitialValues<BasicInfoFormValues>>;

const BasicInfoFormComponent: React.FC<Props> = ({
  dirtyFieldsSinceLastSubmit,
  errors,
  handleSubmit,
  submitting,
  submitErrors,
}) => {
  const invalid = useMemo(
    () =>
      !!(
        submitErrors &&
        Object.keys(submitErrors).some((field) => !(field in dirtyFieldsSinceLastSubmit))
      ) || !isEmpty(errors),
    [dirtyFieldsSinceLastSubmit, errors, submitErrors]
  );
  const genderProps = useField<BasicInfoFormValues['gender']>('gender');
  const dateOfBirthProps = useField<BasicInfoFormValues['dateOfBirth']>('dateOfBirth');
  const zipCodeProps = useFieldWithError<BasicInfoFormValues['zipCode']>('zipCode');

  return (
    <FormWrapper
      id="health-basic-info-life-3-form"
      handleSubmit={handleSubmit}
      invalid={invalid}
      submitting={submitting}
    >
      <ToggleField
        groupLabel="Gender"
        choices={[
          { label: 'Male', value: 'male' },
          { label: 'Female', value: 'female' },
        ]}
        {...genderProps}
      />
      <DateField includeDay label="Date of birth" tooltip={dobToolTip} {...dateOfBirthProps} />
      <MaskedTextField
        autoComplete="postal-code"
        label="ZIP code"
        maskOptions={{ mask: '00000' }}
        inputMode="numeric"
        {...zipCodeProps}
      />
    </FormWrapper>
  );
};

export default BasicInfoFormComponent;
